import { SurveyQuestionText } from 'survey-react-ui';
import { get, invoke } from 'lodash';

import { Fields, BaseFieldProps } from '../../Fields';

import { GetBasePropsParams } from './SurveyText.types';
import { convertSurveyMaskToIMask } from './SurveyText.utils';

export class SurveyText extends SurveyQuestionText {
  private getBaseProps({ error }: GetBasePropsParams): BaseFieldProps<any> {
    return {
      id: this.question.inputId,
      value: this.question.value,
      disabled: this.question.isDisabledAttr,
      error,
      placeholder: this.question.placeholder,
      label: this.question.title,
      onFocus: (event) => this.question.onFocus(event),
      onKeyUp: this.question.onKeyUp.bind(this),
      onKeyDown: this.question.onKeyDown.bind(this),
      onCompositionUpdate: (event) =>
        this.question.onCompositionUpdate(event.nativeEvent),
      readOnly: this.question.isReadOnlyAttr,
    };
  }

  private renderTextElement({ error }: GetBasePropsParams) {
    return (
      <Fields.Text
        {...this.getBaseProps({ error })}
        // @ts-ignore
        autoComplete={this.question.autocomplete}
        maxLength={this.question.getMaxLength()}
        onChange={({ event }) => this.question.onChange(event)}
      />
    );
  }

  private renderDatePickerElement({ error }: GetBasePropsParams) {
    return (
      <Fields.DatePicker
        {...this.getBaseProps({ error })}
        min={this.question.renderedMin}
        max={this.question.renderedMax}
        onChange={({ value }) => this.setValueCore(value)}
      />
    );
  }

  private renderPatternElement({ error }: GetBasePropsParams) {
    const pattern = get(this.question.maskSettings, [
      'propertyHash',
      'pattern',
    ]);

    return (
      <Fields.Pattern
        {...this.getBaseProps({ error })}
        options={convertSurveyMaskToIMask(pattern)}
        onChange={({ value }) => this.setValueCore(value)}
      />
    );
  }

  public renderElement = () => {
    const error = invoke(this.question, ['errors', 0, 'getText']);

    if (this.question.inputType === 'date') {
      return this.renderDatePickerElement({ error });
    }

    if (this.question.maskType === 'pattern') {
      return this.renderPatternElement({ error });
    }

    return this.renderTextElement({ error });
  };
}
